module.exports = __webpack_public_path__ + "linea-arrows-10.4e2921ae2aa6ab286dca.ttf";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/linea-icons/fonts/linea-arrows-10.ttf
// module id = ../../../../../src/assets/scss/icons/linea-icons/fonts/linea-arrows-10.ttf
// module chunks = styles